import React from 'react';
import fullLogoSvg from '../assets/img/AIM Journal full name logo.svg';

const AJHMLogo = ({ isDark = false, className = '', height }) => {
  const formattedHeight = height
    ? (/^\d+$/.test(String(height).trim()) ? `${String(height).trim()}px` : String(height))
    : null;
  const heightStyle = formattedHeight ? { height: formattedHeight, maxHeight: formattedHeight } : {};

  return (
    <div className={`inline-flex items-center select-none ${className}`}>
      <img
        src={fullLogoSvg}
        alt="AJHM - AIM Journal of Homoeopathic Medicine"
        style={heightStyle}
        className={`${
          formattedHeight ? 'w-auto' : 'h-12 sm:h-14 md:h-16 lg:h-20 w-auto'
        } object-contain transition-all ${
          isDark ? 'brightness-0 invert' : ''
        }`}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/assets/img/AIM Journal full name logo.svg';
        }}
      />
    </div>
  );
};

export default AJHMLogo;
